module.exports = __webpack_public_path__ + "media/images/help/faq-search-filter-sp-29fcaba07a95ee552cc591371285cbaf.jpg";